export enum PAGINATION_CONSTANTS {
  PAGE = 1,
  ITEMS_PER_PAGE = 10,
  MAX_LENGTH = 2000,
}
